/* global axios */
import ApiClient from './ApiClient';

class MacrosAPI extends ApiClient {
  constructor() {
    super('macros', { accountScoped: true });
  }

  executeMacro({ macroId, conversationIds, prompts }) {
    const body = { conversation_ids: conversationIds };
    if (prompts && Object.keys(prompts).length > 0) {
      body.prompts = prompts;
    }
    return axios.post(`${this.url}/${macroId}/execute`, body);
  }
}

export default new MacrosAPI();
